module.exports = __webpack_public_path__ + "assets/img/star_score_n.c95521b3.png";